import cx from 'classnames';
import { FC } from 'react';
import styles from './HeaderStoreLocationMap.module.scss';
import { HeaderStoreLocationMapProps } from './types';
import { StoreLocationMap } from '../../store-location-map/StoreLocationMap';

export const HeaderStoreLocationMap: FC<HeaderStoreLocationMapProps> = ({
  userCountryCode,
  dealerCode,
  latitude,
  longitude
}) => {
  return (
    <StoreLocationMap
      userCountryCode={userCountryCode}
      dealerCode={dealerCode}
      latitude={latitude}
      longitude={longitude}
      className={cx('mb-3', styles['store-location-map-container'])}
    />
  );
};
